import { AfterContentChecked, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { UiService } from '../../services/ui.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { Table } from 'primeng/table';
import { AppSettings } from '../../app.settings';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { StorageService } from '../../services/storage.service';
import { formatTimeCellToMin } from '../../utility-functions/grid';
import { Grid2Model } from './grid-2-model';
import { Grid2Service } from './grid2.service';

@Component({
  selector: 'app-mi-grid-v2',
  providers: [Grid2Service],
  templateUrl: './mi-grid-2.component.html',
  styleUrls: ['./mi-grid-2.component.scss']
})

export class MiGrid2Component implements OnInit, OnChanges, OnDestroy, AfterContentChecked {
  subscription: Subscription;
  rowData: any[] = [];
  search = '';
  @Output() rowClickedEvent = new EventEmitter<any>();
  @Output() totalCount = new EventEmitter<any>();
  @Output() eventLocationCount = new EventEmitter<any>();
  /**
   * Opt-in. By default a throwing cell renderer fails loudly so the defect is seen in QA. When true, a failing
   * renderer is logged and the cell falls back to its raw / empty value so the rest of the row still renders.
   */
  @Input() tolerateRendererErrors = false;

  private runRenderer<T>(field: string, render: () => T, fallback: T): T {
    try {
      return render();
    } catch (error) {
      console.error(`Cell renderer failed for column "${field}"`, error);
      return fallback;
    }
  }
  @Output() printQrEvent = new EventEmitter<any>();
  @Output() actionBtnClickedEvent = new EventEmitter<any>();
  @Output() getGridReference: EventEmitter<any> = new EventEmitter();
  @Output() dropDownEvent: EventEmitter<any> = new EventEmitter();
  @Output() dropDownEventTwo: EventEmitter<any> = new EventEmitter();
  @Output() editClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() switchChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() clickEtaEmmiter: EventEmitter<any> = new EventEmitter();
  @Output() checkboxClicked: EventEmitter<any> = new EventEmitter();
  @Output() allCheckboxClicked: EventEmitter<any> = new EventEmitter();
  @Output() mergeCheckboxClicked: EventEmitter<any> = new EventEmitter();
  @Output() allMergeCheckboxClicked: EventEmitter<any> = new EventEmitter();
  @Input() url: any = '';
  @Input() urlMethod: string = AppSettings.METHOD_TYPE.GET;
  @Input() bodyMapping: { [queryKey: string]: { key: string; type: string } };
  @Input() postBody: any = null;
  @Input() bottomSearchBar: Boolean;
  @Input() topBorder: Boolean = true;
  @Input() searchWidth: string = '300';

  @Input() isDetailScreen: Boolean;
  @Input() bottomExportButton: Boolean;
  @Input() rowSelection = 'single';
  @Input() overflowShow: Boolean = false;
  @Input() printUrl: any = '';
  @Input() printQr: boolean = false;
  @Input() openSidebar: boolean = false;
  @Input() showCheckbox: any;
  @Input() exportUrl: any = '';
  @Input() exportUrlSecond: any = '';
  @Input() showSecondaryExport: boolean = false;
  @Input() columnDefs: any[] = [];
  @Input() actionButtonsDefs: any[] = [];
  @Input() pagination: any = true;
  @Input() paginationPageSize: any = 50;
  @Input() paginationStartPage: any = 1;
  @Input() isLimit = true;
  @Input() defaultSortField = '';
  @Input() divClass = '';
  @Input() searchPlaceHolder;
  @Input() uniqId: any;
  @Input() rowConditionClass;
  @Input() rowSecondConditionClass;
  @Input() gridScrollHeight = 'calc(100vh - 200px)';
  @Input() gridTableScrollHeight = 'calc(100vh - 200px)';
  @Input() gridScrollable = false;
  @Input() showActionLegend: boolean = false;
  eventListOptions: any = [];
  selectedEvent;
  gridUrlParams = '';
  eventIdParam;
  @ViewChild('dt') dt: Table;
  searchPlaceHolderValue = '';
  rowClass = 'row-hilight-selection';
  rowSecondClass = 'row-highlight-second-condition-selection';
  queryParams: any = '';
  enableResizer = 'false';
  @Input() overlayLoadingTemplate: any = '<span class="ag-overlay-loading-center" "style=background:red">' +
    'Please wait while your rows are loading</span>';
  datasource = [];
  model: Grid2Model;
  totalRecords = 0;
  dataLoaded = false;
  skeletonRows = new Array(20);
  sortF = '';
  first: any = 0;
  sortO = 'asc';
  offset = 0;
  setRowLength = 50;
  searchText = '';
  selectedRecords: any = [];
  dispatchLocations: any = [];
  private activeGridDropdown: Dropdown | null = null;
  dataAttribute = '';
  @Input() serialNumber;
  /** Append the Global Event Selector id as `eventId`. Off for cross-event grids (e.g. Manage Events). */
  @Input() appendEventId = true;
  /** Empty-state copy (translation key or text); defaults to `label_no_records_found`. */
  @Input() emptyMessage = '';
  /** Empty-state copy when a search term is active; falls back to `emptyMessage`. */
  @Input() emptySearchMessage = '';
  /** When set, a failed load shows this copy in the grid instead of the raw API error toast. */
  @Input() loadErrorMessage = '';
  /** Optional extra content (e.g. a CTA) rendered under the empty-state message when not searching. */
  @Input() emptyStateTemplate: TemplateRef<any> | null = null;
  /**
   * Row clicks only reach `rowClickedEvent` on select; a click on an already-selected row (e.g. after
   * its action menu was opened) unselects it silently. When true, that click is emitted too.
   */
  @Input() emitRowClickOnUnselect = false;
  @Output() loadError = new EventEmitter<any>();
  loadFailed = false;
  subServiceThirdParty = AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY;
  clearSearch;
  no_zone;
  previousScrollTop = 0;
  extraInfo;
  selectedDriverData: any;
  selectedBusData: any;
  selectedCheckbox: Boolean = false;
  selectedMergeBookings: any[] = [];
  selectedMergeCheckbox: Boolean = false;
  gridData: any;
  showScrollToTopButton = false;
  private firstLoadDone = false;
  private sortColumnInitialized = false;
  readonly POST_METHOD_TYPE = AppSettings.METHOD_TYPE.POST;
  readonly defaultNull = AppSettings.GRID_DEFAULT_NULL_VALUE;

  constructor(private elm: ElementRef, private uiService: UiService, private gridService: Grid2Service,
    private commonBindingdataService: CommonBindingDataService,
    private sanitizer: DomSanitizer,
    private storageService: StorageService

  ) {
    this.clearSearch = this.commonBindingdataService.getLabel('label_clear_search');
    this.no_zone = this.commonBindingdataService.getLabel('label_no_zone');
  }

  ngOnInit() {
    this.searchPlaceHolderValue = this.searchPlaceHolder ? this.searchPlaceHolder :
      this.commonBindingdataService.getLabel('label_press_enter_to_search');
    this.setRowLength = this.paginationPageSize;
    this.setGridPagination();
    // Refresh grid when sidebar is toggled
    this.commonBindingdataService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.refreshList();
    });
    if (!this.eventIdParam) {
      let tempEventId = this.commonBindingdataService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
        this.refreshList();
      }
    }

    if (this.uniqId) {

      this.offset = this.storageService.getItemFromSessionStorage(this.uniqId);
      this.offset = this.offset === null ? 0 : this.offset;
    } else {
      this.offset = 0;
    }
  }

  private ensureDefaultSortColumn(): void {
    if (this.sortColumnInitialized) {
      return;
    }
    const hasDefaultSort = this.defaultSortField !== undefined && this.defaultSortField !== null && String(this.defaultSortField).trim() !== '';
    if (!hasDefaultSort) {
      const sortColumn = (this.columnDefs || [])
        .map((c: any) => c?.sortColumn)
        .find((v: any) => v !== undefined && v !== null && String(v).trim() !== '');
      if (sortColumn !== undefined && sortColumn !== null && String(sortColumn).trim() !== '') {
        this.defaultSortField = String(sortColumn).trim();
      }
    }
    if (this.sortF === undefined || this.sortF === null || String(this.sortF).trim() === '') {
      const nextSort = this.defaultSortField !== undefined && this.defaultSortField !== null ? String(this.defaultSortField).trim() : '';
      if (nextSort !== '') {
        this.sortF = nextSort;
      }
    }
    this.sortColumnInitialized = true;
  }
  setGridPagination() {
    const pagination = this.getSavedPagination();
    const obj = pagination?.pageData;
    this.offset = obj?.offset === null || obj?.offset === undefined ? 0 : obj?.offset;
    this.searchText = obj?.searchText === null || obj?.searchText === undefined ? '' : obj?.searchText;
    this.search = obj?.searchText === null || obj?.searchText === undefined ? '' : obj?.searchText;
  }

  getSavedPagination() {
    let pagination: any[] = this.storageService.getItemFromSessionStorage(AppSettings.PAGINATION);
    pagination = pagination ? pagination : [];
    const objects = pagination.filter(ele => {
      return ele.uniqId === this.uniqId;
    });
    if (objects.length > 0) {
      return objects[0];
    } else {
      return null;
    }
  }

  updatePageDataToLocal(pageData: any, key?, val?) {
    let pagination: any[] = this.storageService.getItemFromSessionStorage(AppSettings.PAGINATION);
    pagination = pagination ? pagination : [];
    const objects = pagination.filter(ele => {
      return ele.uniqId === pageData.uniqId;
    });

    if (objects.length === 0 && pageData.uniqId) {
      pagination.push(pageData);
    } else {
      const index = pagination.findIndex(ele => ele.uniqId === pageData.uniqId);
      if (index >= 0) {
        if (key && val) {
          pagination[index]['pageData'][key] = val;
        } else {
          pagination[index] = pageData;
        }
      }
    }
    this.storageService.setSessionStorage(AppSettings.PAGINATION, pagination);
  }

  ngOnChanges() {
    if (this.searchPlaceHolder) {
      this.searchPlaceHolderValue = this.searchPlaceHolder;
    }
    this.commonBindingdataService.selectedDriverData.subscribe(result => {
      this.selectedDriverData = result
    })
    this.commonBindingdataService.selectedBusData.subscribe(result => {
      this.selectedBusData = result
    })
  }

  ngAfterContentChecked() {
    const element = document.getElementById('p-table-list');
    element?.scrollTo(0, (this.previousScrollTop));
  }

  onChangeScroll(event) {
    // Get scrollTop from the actual scrollable container
    const scrollableElement = this.elm.nativeElement.querySelector('.scroll-bar-css');
    const scrollTop = scrollableElement ? scrollableElement.scrollTop : 0;
    this.previousScrollTop = scrollTop;

    // Show/hide scroll-to-top button based on scroll position
    this.showScrollToTopButton = scrollTop > 100;
  }

  scrollToTop() {
    // Find the scrollable container within the grid
    const scrollableElement = this.elm.nativeElement.querySelector('.scroll-bar-css');
    if (scrollableElement) {
      scrollableElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      // Also reset the previousScrollTop to maintain consistency
      this.previousScrollTop = 0;
      this.showScrollToTopButton = false;
    }
  }

  onResize(event: any) {
  }

  refreshList() {
    this.dataLoaded = false;
    this.ensureDefaultSortColumn();
    if (this.url !== null && this.url !== '') {
      this.fetchAndLoadData();
    }
  }

  fetchAndLoadData() {
    if (this.url === null || this.url === '') {
      return null;
    }
    this.dataLoaded = false;
    this.loadFailed = false;
    this.datasource = [];
    const that = this;
    const requestBody = this.urlMethod === this.POST_METHOD_TYPE ? this.buildEffectivePostBody() : null;
    this.gridService.loadGridData(that.getUrl(that.url), that.urlMethod, requestBody).subscribe(result => {      
    this.gridData = result;
    
      const model = <Grid2Model>result;
      if (result !== undefined) {
        this.totalRecords = model.count;
        this.dataLoaded = true;
        that.datasource = [];
        model.data = model.data ? model.data : [];

        if (that.serialNumber) {
          let serialNo = this.offset + 1;
          for (let i = 1, j = serialNo; i <= model.data.length; i++, j++) {
            model.data[i - 1]['serialNumber'] = j;
          }
        }
        model.data.forEach(e => {
          that.columnDefs.forEach(c => {
            if (c && c.cellRenderer) {
              e[c.field] = this.tolerateRendererErrors
                ? this.runRenderer(c.field, () => c.cellRenderer(e[c.field]), e[c.field])
                : c.cellRenderer(e[c.field]);
            } else if (c && c.cellRendererHtml) {
              const renderedHtml = this.sanitizer.bypassSecurityTrustHtml(
                this.tolerateRendererErrors
                  ? this.runRenderer(c.field, () => c.cellRendererHtml(e)?.innerHTML || '', '')
                  : c.cellRendererHtml(e).innerHTML
              );
              if (c.isDropDown) {
                e[this.getDropdownCellHtmlKey(c.field)] = renderedHtml;
              } else {
                e[c.field] = renderedHtml;
              }
            }
            that.actionButtonsDefs.forEach(d => {
              if (d.show) {
                e[d.field] = d.show(e);
              }
            });
          });
          that.datasource.push(e);
        });
        this.extraInfo = model.extraData;
      }
      this.totalCount.emit(this.totalRecords);
      if (model?.eventLocationCount != null) {
        this.eventLocationCount.emit(Number(model.eventLocationCount));
      }
      this.dt.first = this.offset;
    }, (error) => {
      this.dataLoaded = true;
      this.loadFailed = true;
      this.loadError.emit(error);
      if (this.loadErrorMessage) {
        return;
      }
      this.uiService.showMessage(error?.general?.[0]?.message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  get resolvedEmptyMessage(): string {
    if (this.loadFailed && this.loadErrorMessage) {
      return this.loadErrorMessage;
    }
    if (this.searchText?.trim() && this.emptySearchMessage) {
      return this.emptySearchMessage;
    }
    return this.emptyMessage || 'label_no_records_found';
  }

  get showEmptyStateTemplate(): boolean {
    return !!this.emptyStateTemplate && !this.loadFailed && !this.searchText?.trim();
  }

  getUrl(baseUrl) {
    const that = this;
    const obj = {
      uniqId: this.uniqId,
      pageData: {
        offset: this.offset,
        searchText: this.searchText
      }
    };
    this.updatePageDataToLocal(obj);
    let url = ''
    if (this.searchText.length > 0 && baseUrl.includes("assign-trip")) {
      const paramArray = baseUrl.split('?');
      if (paramArray.length > 1) {
        const searchParams = new URLSearchParams(paramArray[1]);
        const params = new URLSearchParams();

        if (searchParams.has('fromDate')) {
          params.set('fromDate', searchParams.get('fromDate')!);
        }

        if (searchParams.has('toDate')) {
          params.set('toDate', searchParams.get('toDate')!);
        }

        if (searchParams.has('dedicatedTourId')) {
          params.set('dedicatedTourId', searchParams.get('dedicatedTourId')!);
        }

        if (searchParams.has('dedicatedTourDaywiseDataId')) {
          params.set(
            'dedicatedTourDaywiseDataId',
            searchParams.get('dedicatedTourDaywiseDataId')!
          );
        }

        url = `${paramArray[0]}?${params.toString()}`;
      }
    } else {
      url = baseUrl;
    }
    const effectiveLimit = this.isLimit ? this.setRowLength : 999999;
    let params = 'searchText=' + this.searchText.trim() + '&offset=' + this.offset + '&limit=' + effectiveLimit;
    this.storageService.setSessionStorage(this.uniqId, this.offset);
    params += '&sortColumn=';
    params += this.sortF === 'createdAtStr' ? 'createdAt' : this.sortF;
    params += '&sortType=';
    params += this.sortO;

    if (this.urlMethod === this.POST_METHOD_TYPE) {
      const baseUrl = url.split('?')[0];
      if (that.url.lastIndexOf('?') < 0) {
        this.gridUrlParams = '';
      } else {
        this.gridUrlParams = that.url.substring(that.url.lastIndexOf('?') + 1);
      }
      return baseUrl + '?' + params;
    }

    // Cross-event grids (appendEventId = false) are never scoped by the Global Event Selector.
    if (this.appendEventId) {
      params += '&eventId=' + (this.eventIdParam != undefined ? this.eventIdParam : this.commonBindingdataService.changedEventId);
    }

    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }

    if (that.url.lastIndexOf('?') < 0) {
      this.gridUrlParams = '';
    } else {
      this.gridUrlParams = that.url.substring(that.url.lastIndexOf('?') + 1);
    }
    buildUrl += params;

    return buildUrl;
  }

  private buildPostBodyFromUrl(originalUrl: string): any {
    const body: any = {};
    if (!this.bodyMapping) {
      return body;
    }
    const queryString = originalUrl.split('?')[1] || '';
    const urlParams = new URLSearchParams(queryString);

    Object.keys(this.bodyMapping).forEach(queryKey => {
      const raw = this.bodyMapping[queryKey];
      const cfg = typeof raw === 'string' ? { key: queryKey, type: raw } : raw;
      const rawValue = urlParams.get(queryKey);

      if (rawValue === null || rawValue === '') {
        switch (cfg.type) {
          case 'array': body[cfg.key] = []; break;
          case 'number': body[cfg.key] = null; break;
          case 'boolean': body[cfg.key] = null; break;
          default: body[cfg.key] = ''; break;
        }
      } else {
        switch (cfg.type) {
          case 'array':
            body[cfg.key] = rawValue.split(',').filter(v => v !== '');
            break;
          case 'number':
            body[cfg.key] = Number(rawValue);
            break;
          case 'boolean':
            body[cfg.key] = (rawValue === 'true');
            break;
          default:
            body[cfg.key] = rawValue;
        }
      }
    });

    return body;
  }

  private buildEffectivePostBody(): any {
    const baseBody = this.postBody
      ? { ...(this.postBody) }
      : this.buildPostBodyFromUrl(this.url);

    const eventId = this.eventIdParam != undefined
      ? this.eventIdParam
      : this.commonBindingdataService.changedEventId;

    return { ...baseBody, eventId };
  }

  public onQuickFilterChanged($event, dt) {
    if (this.search === '') {
      this.search = this.searchText = '';
      this.refreshList();
    }
    if ($event.key === 'Enter') {
      this.applySearch(this.search);
      dt.first = 0;
    }
  }

  updateUrl(url: string, postBody?: any) {
    this.url = url;
    if (postBody !== undefined) {
      this.postBody = postBody;
    }
    this.offset = 0;
    this.dataLoaded = false;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    }
    this.refreshList();
  }

  getQueryParam(url: string) {
    this.offset = 0;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    }
    return this.queryParams;
  }

  onResetSearchInput() {
    if (this.search) {
      this.search = this.searchText = '';
      this.offset = 0;
      this.refreshList();
    }
  }

  resetGridToDefault(refresh = true): void {
    this.search = '';
    this.searchText = '';
    this.sortF = '';
    this.sortO = 'asc';
    this.offset = 0;
    this.first = 0;

    if (this.uniqId) {
      this.storageService.setSessionStorage(this.uniqId, 0);
      this.updatePageDataToLocal({
        uniqId: this.uniqId,
        pageData: {
          offset: 0,
          searchText: ''
        }
      });
    }

    if (this.dt) {
      this.dt.sortField = null;
      this.dt.sortOrder = 0;
      this.dt.first = 0;
    }

    if (refresh && this.url !== null && this.url !== '') {
      this.refreshList();
    }
  }

  loadDatasourceLazy(event: LazyLoadEvent) {
    if (!this.firstLoadDone) {
      this.firstLoadDone = true;
      return;
    }
    this.ensureDefaultSortColumn();
    this.sortF = this.defaultSortField;
    this.offset = event.first;
    this.setRowLength = event.rows;
    if (event.sortField !== undefined) {
      this.sortF = event.sortField;
    }
    this.sortO = event.sortOrder > 0 ? 'asc' : 'desc';
    this.fetchAndLoadData();
  }

  onRowSelect(event) {
    this.rowClickedEvent.emit(event);
  }

  onRowUnselect(event?) {
    this.selectedRecords = [];
    if (this.emitRowClickOnUnselect && event) {
      this.rowClickedEvent.emit(event);
    }
  }

  selectAll(event, rowData) {
    this.allCheckboxClicked.emit(event)
  }

  printQRCodes(event) {
    this.printQrEvent.emit(event);
  }

  actionBtnClick(event, data: any, action: string) {
    event.stopPropagation();
    const obj = { row: data, class: action };
    this.actionBtnClickedEvent.emit(obj);
  }

  clearRowSelection() {
    const emptyValue = this.rowSelection === 'multiple' ? [] : null;
    this.selectedRecords = emptyValue;
    if (this.dt) {
      this.dt.selection = emptyValue;
      if ((this.dt as any).selectionKeys) {
        (this.dt as any).selectionKeys = {};
      }
      if (this.dt.selectionChange) {
        this.dt.selectionChange.emit(emptyValue);
      }
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  getSelectedRecords() {
    return this.selectedRecords;
  }

  applySearch(searchText: string) {
    this.searchText = searchText;
    this.offset = 0;
    this.first = 0;
    this.fetchAndLoadData();
  }

  exportGridExcel(event: any) {
    const that = this;
    console.log('exportGridExcel', that.exportUrl);
    console.log('urlMethod', this.urlMethod);
    if (this.urlMethod === this.POST_METHOD_TYPE) {
      const buildUrl = that.getUrl(that.exportUrl);
      const requestBody = this.buildEffectivePostBody();
      this.gridService.downloadExcelGridDataPost(buildUrl, requestBody);
    } else {
      let buildUrl = that.getUrl(that.exportUrl);
      const tempUrl = that.getUrl(that.exportUrl);
      if (tempUrl.lastIndexOf('?') < 0) {
        buildUrl += '?' + this.gridUrlParams;
      } else {
        buildUrl += '&' + this.gridUrlParams;
      }
      this.gridService.downloadExcelGridData(buildUrl);
    }
  }
  exportGridExcelSecondary(event: any) {
    const that = this;
    let buildUrl = that.getUrl(that.exportUrlSecond);
    const tempUrl = that.getUrl(that.exportUrlSecond);
    if (tempUrl.lastIndexOf('?') < 0) {
      buildUrl += '?' + this.gridUrlParams;
    } else {
      buildUrl += '&' + this.gridUrlParams;
    }
    this.gridService.downloadExcelGridData(buildUrl);
  }

  exportGridPdf(event: any) {
    const that = this;
    if (this.urlMethod === this.POST_METHOD_TYPE) {
      const buildUrl = that.getUrl(that.printUrl);
      const requestBody = this.buildEffectivePostBody();
      this.gridService.downloadPdfGridDataPost(buildUrl, requestBody);
    } else {
      let buildUrl = that.getUrl(that.printUrl);
      const tempUrl = that.getUrl(that.printUrl);
      if (tempUrl.lastIndexOf('?') < 0) {
        buildUrl += '?' + this.gridUrlParams;
      } else {
        buildUrl += '&' + this.gridUrlParams;
      }
      this.gridService.downloadPdfGridData(buildUrl);
    }
  }

  onDropDownChange(event: any, data, type?: any) {
    event.data = data;
    event.type = type;
    this.dropDownEvent.emit(event);
  }
  getDropdownLabel(options: any[], value: any): string {
    const selectedOption = options.find(option => option.value === value);
    return selectedOption ? selectedOption.label : '';
  }

  onDropDownEventTwoChange(event: any, data) {
    event.data = data;
    this.dropDownEventTwo.emit(event);
  }

  onSelectClick(event) {
    this.dataAttribute = event.currentTarget.getAttribute('data-action-type');
  }

  onSelectAllCheckboxClick(event, data) {
    this.selectedCheckbox = event.target.ariaHidden == "true" ? false : true;
    if (this.selectedCheckbox) {
      this.allCheckboxClicked.emit({ isChecked: this.selectedCheckbox, data: this.gridData.data });
    } else {
      this.allCheckboxClicked.emit({ isChecked: false, data: [] });
      this.selectedDriverData = []
      this.selectedBusData = []
    }
  }

  onCheckboxClick(event: any, rowData: any) {
    event.stopPropagation();
    const isChecked = event.target.checked;
    if (isChecked) {
      this.selectedRecords.push(rowData);
    } else {
      this.selectedRecords = this.selectedRecords.filter(record => record !== rowData);
    }
    this.checkboxClicked.emit({
      event,
      data: rowData,
      isChecked
    });
  }

  isRowSelected(rowData: any): boolean {
    return this.selectedRecords.includes(rowData);
  }

  isMergeRowSelected(rowData: any): boolean {
    return this.selectedMergeBookings.some(booking => booking.id === rowData.id);
  }

  isAllMergeRowsSelected(): boolean {
    if (!this.gridData?.data || this.gridData.data.length === 0) {
      return false;
    }
    return this.gridData.data.every(row => this.selectedMergeBookings.some(booking => booking.id === row.id));
  }

  // Merge popup checkbox methods
  onMergeCheckboxClick(event: any, rowData: any) {
    event.stopPropagation();
    const isChecked = event.target.checked;
    if (isChecked) {
      this.selectedMergeBookings.push(rowData);
    } else {
      this.selectedMergeBookings = this.selectedMergeBookings.filter(record => record !== rowData);
    }

    // Update header checkbox state based on individual selections
    this.updateMergeHeaderCheckboxState();

    this.mergeCheckboxClicked.emit({
      event,
      data: rowData,
      isChecked
    });
  }

  updateMergeHeaderCheckboxState() {
    if (!this.gridData?.data || this.gridData.data.length === 0) {
      this.selectedMergeCheckbox = false;
      return;
    }

    // Check if all rows are selected
    const allSelected = this.gridData.data.every(row =>
      this.selectedMergeBookings.some(booking => booking.id === row.id)
    );

    this.selectedMergeCheckbox = allSelected;
  }

  onMergeSelectAllCheckboxClick(event: any) {
    this.selectedMergeCheckbox = event.target.checked;
    if (this.selectedMergeCheckbox) {
      this.allMergeCheckboxClicked.emit({ isChecked: this.selectedMergeCheckbox, data: this.gridData.data });
    } else {
      this.allMergeCheckboxClicked.emit({ isChecked: false, data: [] });
      this.selectedMergeBookings = [];
    }
  }

  onEditClick(event: any, data) {
    event.stopPropagation();
    event.data = data;
    this.editClickEvent.emit(event);
  }

  onDropDownClick(event: any, data) {
    event.stopPropagation();
  }

  isColumnDropdownDisabled(col: any, rowData: any): boolean {
    if (col?.disabled) {
      return true;
    }

    if (col?.disableField) {
      const disableFields = Array.isArray(col.disableField) ? col.disableField : [col.disableField];
      const isAnyRequiredFieldFalsy = disableFields.some((field) => {
        const fieldValue = rowData?.[field];
        return !(fieldValue === true || fieldValue === 'true');
      });
      if (isAnyRequiredFieldFalsy) {
        return true;
      }
    }

    if (col?.disableWhenField) {
      const fieldValue = rowData?.[col.disableWhenField];
      const disableValues = Array.isArray(col.disableWhenValues)
        ? col.disableWhenValues
        : [false, 'false', 'OFF'];

      const isMatch = disableValues.some((value) => {
        if (value === fieldValue) {
          return true;
        }
        return String(value).toLowerCase() === String(fieldValue).toLowerCase();
      });

      if (isMatch) {
        return true;
      }
    }

    return false;
  }

  onGridDropdownShow(dropdown: Dropdown): void {
    if (this.activeGridDropdown && this.activeGridDropdown !== dropdown) {
      this.activeGridDropdown.hide();
    }
    this.activeGridDropdown = dropdown;
  }

  onGridDropdownHide(dropdown: Dropdown): void {
    if (this.activeGridDropdown === dropdown) {
      this.activeGridDropdown = null;
    }
  }

  onSwitchChange(event, data) {
    event.data = data;
    this.switchChangeEvent.emit(event);
  }

  getDropdownColor(rowData) {
    if (rowData.requestStatus === 1 || rowData.incidentStatus == 'NEW') {
      return 'cond-color new';
    } else if (rowData.requestStatus === 2 || rowData.incidentStatus == 'ATTENDED') {
      return 'cond-color attended';
    } else if (rowData.requestStatus === 3 || rowData.incidentStatus == 'CLOSED') {
      return 'cond-color closed';
    } else {
      return '';
    }
  }

  isEmergency(rowData: any): boolean {
    return !!(rowData && rowData.showAlertForSpecialRequest);
  }

  getRowClassName(rowData) {
    return rowData[this.rowConditionClass];
  }

  checkClassCondition(rowData) {
    if (rowData[this.rowConditionClass]) {
      return true;
    }
    return false;
  }

  //  AELTC Specific Start

  getDepartureTime(rowData) {
    let departureTime = '-'
    if (rowData) {
      departureTime = formatTimeCellToMin(rowData);
    }
    return departureTime;
  }

  checkIsEditable(bookingStatus) {
    return (AppSettings.DRIVER_ASSIGN_CONDITIONS_edit.indexOf(bookingStatus) > -1);
  }

  onEtaClick(event, data: any) {
    event.stopPropagation();
    const obj = { row: data };
    this.clickEtaEmmiter.emit(obj);
  }

  onPageChange(event: any) {
    this.offset = event.first;
    this.paginationPageSize = event.rows;
    this.fetchAndLoadData();
  }

  private parseColorToRgb(color: string): { r: number; g: number; b: number } | null {
    if (!color) {
      return null;
    }
    const trimmed = color.trim();
    // Hex formats: #RRGGBB or #RGB
    const hexMatch = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(trimmed);
    if (hexMatch) {
      let hex = hexMatch[1];
      if (hex.length === 3) {
        hex = hex.split('').map(ch => ch + ch).join('');
      }
      const intVal = parseInt(hex, 16);
      return {
        r: (intVal >> 16) & 255,
        g: (intVal >> 8) & 255,
        b: intVal & 255
      };
    }
    const rgbMatch = /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)$/.exec(trimmed);
    if (rgbMatch) {
      const r = Math.max(0, Math.min(255, Math.round(parseFloat(rgbMatch[1]))));
      const g = Math.max(0, Math.min(255, Math.round(parseFloat(rgbMatch[2]))));
      const b = Math.max(0, Math.min(255, Math.round(parseFloat(rgbMatch[3]))));
      return { r, g, b };
    }
    return null;
  }

  public toRgba20(color: string): string {
    const rgb = this.parseColorToRgb(color);
    if (!rgb) {
      return color;
    }
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)`;
  }

  public toRgbTriplet(color: string): string {
    const rgb = this.parseColorToRgb(color);
    if (!rgb) {
      return '255, 205, 210';
    }
    return `${rgb.r}, ${rgb.g}, ${rgb.b}`;
  }

  getDropdownCellHtmlKey(field: string): string {
    return `${field}__cellHtml`;
  }

  getRowCellHtml(rowData: any, field: string): any {
    return rowData?.[this.getDropdownCellHtmlKey(field)];
  }

}
